import { render, staticRenderFns } from "./ProgramaGestaoDesempenho.vue?vue&type=template&id=6658cd0b"
import script from "./ProgramaGestaoDesempenho.vue?vue&type=script&lang=js"
export * from "./ProgramaGestaoDesempenho.vue?vue&type=script&lang=js"
import style0 from "./ProgramaGestaoDesempenho.vue?vue&type=style&index=0&id=6658cd0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports